module.exports = __webpack_public_path__ + "static/media/doutorFinancas.ef9329b5.png";